import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.function.bind";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.assign";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { getScrollbarSize } from './domUtils';
export function getColumnMetrics(metrics) {
  var left = 0;
  var totalWidth = 0;
  var allocatedWidths = 0;
  var unassignedColumnsCount = 0;
  var lastFrozenColumnIndex = -1;
  var columns = [];

  for (var _iterator = _createForOfIteratorHelperLoose(metrics.columns), _step; !(_step = _iterator()).done;) {
    var metricsColumn = _step.value;
    var width = getSpecifiedWidth(metricsColumn, metrics.columnWidths, metrics.viewportWidth);

    if (width === undefined) {
      unassignedColumnsCount++;
    } else {
      width = clampColumnWidth(width, metricsColumn, metrics.minColumnWidth);
      allocatedWidths += width;
    }

    var column = Object.assign({}, metricsColumn, {
      width: width
    });

    if (column.frozen) {
      lastFrozenColumnIndex++;
      columns.splice(lastFrozenColumnIndex, 0, column);
    } else {
      columns.push(column);
    }
  }

  var unallocatedWidth = metrics.viewportWidth - allocatedWidths - getScrollbarSize();
  var unallocatedColumnWidth = Math.max(Math.floor(unallocatedWidth / unassignedColumnsCount), metrics.minColumnWidth);
  var calculatedColumns = columns.map(function (column, idx) {
    var _column$width, _column$formatter; // Every column should have a valid width as this stage


    var width = (_column$width = column.width) !== null && _column$width !== void 0 ? _column$width : clampColumnWidth(unallocatedColumnWidth, column, metrics.minColumnWidth);
    var newColumn = Object.assign({}, column, {
      idx: idx,
      width: width,
      left: left,
      formatter: (_column$formatter = column.formatter) !== null && _column$formatter !== void 0 ? _column$formatter : metrics.defaultFormatter
    });
    totalWidth += width;
    left += width;
    return newColumn;
  });
  return {
    columns: calculatedColumns,
    lastFrozenColumnIndex: lastFrozenColumnIndex,
    totalColumnWidth: totalWidth
  };
}

function getSpecifiedWidth(_ref, columnWidths, viewportWidth) {
  var key = _ref.key,
      width = _ref.width;

  if (columnWidths.has(key)) {
    // Use the resized width if available
    return columnWidths.get(key);
  }

  if (typeof width === 'number') {
    return width;
  }

  if (typeof width === 'string' && /^\d+%$/.test(width)) {
    return Math.floor(viewportWidth * parseInt(width, 10) / 100);
  }

  return undefined;
}

function clampColumnWidth(width, _ref2, minColumnWidth) {
  var minWidth = _ref2.minWidth,
      maxWidth = _ref2.maxWidth;
  width = Math.max(width, minWidth !== null && minWidth !== void 0 ? minWidth : minColumnWidth);

  if (typeof maxWidth === 'number') {
    return Math.min(width, maxWidth);
  }

  return width;
} // Logic extented to allow for functions to be passed down in column.editable
// this allows us to decide whether we can be editing from a cell level


export function canEdit(column, row) {
  if (typeof column.editable === 'function') {
    return column.editable(row);
  }

  return Boolean(column.editor || column.editable);
}
export function getColumnScrollPosition(columns, idx, currentScrollLeft, currentClientWidth) {
  var left = 0;
  var frozen = 0;

  for (var i = 0; i < idx; i++) {
    var column = columns[i];

    if (column) {
      if (column.width) {
        left += column.width;
      }

      if (column.frozen) {
        frozen += column.width;
      }
    }
  }

  var selectedColumn = columns[idx];

  if (selectedColumn) {
    var scrollLeft = left - frozen - currentScrollLeft;
    var scrollRight = left + selectedColumn.width - currentScrollLeft;

    if (scrollLeft < 0) {
      return scrollLeft;
    }

    if (scrollRight > currentClientWidth) {
      return scrollRight - currentClientWidth;
    }
  }

  return 0;
}